import { Component, HostListener, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

export interface SessionExpirationWarningOptions {
  expiration: moment.Moment;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-session-expiration-warning',
  templateUrl: './session-expiration-warning.component.html',
  styleUrls: ['./session-expiration-warning.component.scss'],
  standalone: false,
})
export class SessionExpirationWarningComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public minutesRemaining: string;

  @HostListener('click', ['$event']) onClick($event) {
    $event.stopImmediatePropagation();
  }

  constructor(
    private dialogRef: MatDialogRef<SessionExpirationWarningComponent>,
    @Inject(MAT_DIALOG_DATA) private data: SessionExpirationWarningOptions
  ) {
    const interval = setInterval(
      () => (this.minutesRemaining = this.data.expiration.fromNow()),
      1000
    );

    this.dialogRef.afterClosed().subscribe(() => {
      clearInterval(interval);
    });
  }

  public confirm(): void {
    this.dialogRef.close({
      extendSession: true,
    });
  }
}
